import requestFlow from '@/utils/requestFlow'
import { bankMandateListRoutine, BANK_CLEANUP, SET_BANK_MANDATE_STATUS } from '@/store/modules/bank/routines'

export default {
  ...requestFlow(bankMandateListRoutine).mockMutations,
  [bankMandateListRoutine.SUCCESS](state, payload) {
    state.bankMandateList = payload
  },

  [BANK_CLEANUP](state, payload) {
    Object.assign(state, payload)
  },

  [SET_BANK_MANDATE_STATUS](state, status) {
    state.bankMandateList = []
    state.bankMandateStatus = status
  }
}
